/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useRef, useState, useEffect, useCallback } from "react";
import { useWindowSize } from "cms/hooks/use-window-size";

const TabNav = (props) => {
    const { tabs, selectTab } = props;
    let tabNavRef = useRef(null);
    const { windowSize } = useWindowSize();
    const [tabsClass, setTabsClass] = useState("tab-nav");

    const getClassNames = useCallback(() => {
        let cn = "tab-nav";
        if (tabNavRef.current && tabNavRef.current.clientHeight > 54) {
            cn = cn + " wrap";
        }

        if (tabs.length > 3) {
            cn = cn + " long";
        }
        if (tabs.length <= 3 && windowSize.width > 580) {
            cn = cn.replace(" wrap", "");
        }
        console.log(cn);
        setTabsClass(cn);
    }, [tabs, windowSize]);

    useEffect(() => {
        // onload
        getClassNames();

        const handleResize = () => {
            getClassNames();
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [getClassNames, tabs]);

    return (
        <div className="tab-nav-wrapper" ref={tabNavRef}>
            <ul className={tabsClass} role="tablist">
                {tabs.map((tab, index) => (
                    <li
                        key={tab.guid}
                        data-tab-index={index}
                        role="tab"
                        tabIndex={index}
                        aria-selected={tab.isVisible}
                        aria-controls={tab.guid}
                        id={tab.guid}
                        onClick={(event) => selectTab(event, tab.guid)}
                        className={tab.isVisible ? "active" : ""}
                        title={tab.title}
                    >
                        <span>{tab.title}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

TabNav.displayName = "TabNav";
export { TabNav };

